import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';

/* actions */
import * as Actions from '../../redux/actions';
import {setLoginCode} from "../../redux/actions";
import store from "../../redux";

class ValidateHotUser extends baseRequest {

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name = 'Validate Hot User Request';
        this.Config = new AppConfig();
        this.route = null;
        this.payload = null; // Add instance variable to store payload
        console.log('is-member initialized');
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload; // Store the payload

        console.log('Executing request with payload:', payload);
        // this.call(this.Config.api.requests.isMember, payload);
        if(payload.id && !payload.userId){
            payload.userId = payload.id;
        }

        if(!payload.deviceId){
            payload.deviceId = 'deviceId';
        }

        this.call(this.Config.api.requests.isMember, payload, 'post', {
            //local
            // basePath: 'http://localhost:9000/users/api/details',
            //dev
            basePath: '//' + window.apiUrl + '/users/api/details',
            stringifyData: true,
        });
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        console.log("payload", this.payload)
        console.log("response", this.response.data)
        this.dispatch(Actions.setLoginCode(this.response.data.loginCode));
        this.dispatch(Actions.setUserIdLogin(Number(this.payload.id)))
    }

    onFailure() {
        console.log('Request failed with error:', this.response.err);
        AnalyticsManager.logLoginFailed();
        this.dispatch(Actions.setLoginReturn(this.response.err));
        this.dispatch(Actions.setLockdownErr(this.response.err));
        this.dispatch(Actions.setLoginCode(this.response.err.id));
    }
}

export default ValidateHotUser;
